import React, { useEffect, useState } from 'react';
import { Text } from '@primer/react';
import { XIcon } from '@primer/octicons-react'

interface ModalSheetProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    children: (props: { setTitle: (title: string) => void }) => React.ReactNode;
    size?: 'small' | 'middle';
    headerSize: 'regular' | 'large';
}

const ModalSheet: React.FC<ModalSheetProps> = ({
    isOpen,
    onClose,
    title,
    children,
    size = 'small',
    headerSize = 'regular'
}) => {
    const [modalTitle, setModalTitle] = useState(title);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    const sizeClasses = {
        small: 'max-w-[320px]',
        middle: 'max-w-[560px]',
    };

    const headerSizeClasses = {
        regular: '14px',
        large: '20px',
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-end justify-center">
            <div
                className={`absolute inset-0 bg-aloix-overlay transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'
                    }`}
            />

            <div
                className={`
          relative w-full ${sizeClasses[size]} mb-6
          bg-white rounded-xl shadow-xl
          transform transition-all duration-300 ease-out
          ${isOpen ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}
        `}
                style={{ maxHeight: '90vh' }}
            >
                {title && (
                    <div className="flex items-center justify-between pl-[14px] pr-[14px] pt-[14px]">
                        <span className={`text-[${headerSizeClasses[headerSize]}] text-aloix-black font-semibold`}>{modalTitle}</span>
                        <button
                            onClick={onClose}
                            className="hover:bg-gray-100 rounded-lg transition-colors" // -mt-4
                        >
                            <XIcon size={16} />
                        </button>
                    </div>
                )}

                <div className='pl-[14px] pr-[14px] pb-[14px] overflow-y-auto' style={{ maxHeight: title ? 'calc(90vh - 80px)' : '90vh' }}>
                    {children({ setTitle: setModalTitle })}
                </div>
            </div>
        </div>
    );
};

export default ModalSheet;